import { useContext } from 'react';
import type { TModalsContext } from '../contexts/DocumentCounterpartiesContext';
import { DocumentCounterpartiesContextExtended } from '../contexts/DocumentCounterpartiesContext';

export default function useCounterpartiesContext(): TModalsContext {
  return useContext(DocumentCounterpartiesContextExtended);
}
